"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpFormDataSerializer = void 0;
const utils_1 = require("@leavy/utils");
/**
 * Serialize an object into a FormData used when the encoding type is set to "multipart/form-data"
 */
class HttpFormDataSerializer {
    populateFormData(formData, data, propertyPath) {
        if (typeof data === "object" && data !== null && this.canParseObject(data)) {
            utils_1.ObjectUtils.keys(data).forEach(key => {
                this.populateFormData(formData, data[key], propertyPath ? `${propertyPath}[${key}]` : key);
            });
        }
        else {
            if (!propertyPath) {
                throw new Error("Data must be an object");
            }
            if (data !== undefined) {
                formData.append(propertyPath, data);
            }
        }
    }
}
exports.HttpFormDataSerializer = HttpFormDataSerializer;
//# sourceMappingURL=HttpFormDataSerializer.js.map